import { render } from "./InboundItemsFormView.vue?vue&type=template&id=f5451f2e"
import script from "./InboundItemsFormView.vue?vue&type=script&lang=js"
export * from "./InboundItemsFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__